import axios from 'axios';
import { AI_FUNCTIONS_BASE_URL } from '../config/api';

const visible = (entry) => entry?.showOnResume !== false;

export const buildResumeTitleContext = (formData = {}) => ({
  professionalSummary: formData.professionalSummary || '',
  selectedSkills: Array.isArray(formData.selectedSkills)
    ? formData.selectedSkills.slice(0, 40)
    : [],
  skills: Array.isArray(formData.skills) ? formData.skills.slice(0, 40) : [],
  workHistory: (Array.isArray(formData.workHistory) ? formData.workHistory : [])
    .filter(visible)
    .slice(0, 20)
    .map((job) => ({
      jobTitle: job?.jobTitle || '',
      responsibilities: job?.responsibilities || '',
      keyAccomplishments: job?.keyAccomplishments || '',
      enhancedResponsibilities: job?.enhancedResponsibilities || [],
      enhancedAccomplishments: job?.enhancedAccomplishments || [],
    })),
  educationHistory: (Array.isArray(formData.educationHistory) ? formData.educationHistory : [])
    .filter(visible)
    .slice(0, 15)
    .map((education) => ({
      degree: education?.degree || '',
      major: education?.major || '',
      relevantCourses: education?.relevantCourses || [],
      significantProjects: education?.significantProjects || [],
    })),
  certifications: Array.isArray(formData.certifications)
    ? formData.certifications.slice(0, 30)
    : [],
  training: Array.isArray(formData.training) ? formData.training.slice(0, 30) : [],
});

export const inferResumeTitle = async (formData = {}) => {
  const jobDescription = (
    formData.oneShotJobDescription
    || formData.combinedManualText
    || formData.parsedJobAnnouncement?.raw
    || ''
  );
  const response = await axios.post(
    `${AI_FUNCTIONS_BASE_URL}/api/jobSeriesSearchHttp`,
    {
      prompt: 'inferResumeTitle',
      userID: formData.user,
      jobDescription,
      resumeData: buildResumeTitleContext(formData),
    },
    { headers: { 'Content-Type': 'application/json' } },
  );
  return String(response.data?.title || '').trim();
};

export default inferResumeTitle;
